import React, { useMemo } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import NewCollapsibleTable from '../../Table/NewCollapsibleTable'

const LobbyistExpendituresPanel = ({ config }) => {
  const { recordDetails } = useSelector((state) => state.record, shallowEqual)

  const subTemplate = useMemo(() => {
    return config.FieldSettings['Expenditures']
      ? [
          {
            ArrayAccessor: 'Expenditures',
            DisplayName: 'Expenditures',
            EmptyMessage: 'No Expenditures during this legislative year.',
            Template: Object.entries(config.FieldSettings['Expenditures'].Fields)
              .filter(([key, val]) => val.IsEnabled)
              .map(([key, val]) => ({
                DisplayName: val.DisplayName,
                Accessor: key,
                IsEnabled: val.IsEnabled,
              })),
          },
        ]
      : []
  }, [config])

  return (
    <div
      className="row"
      style={{ marginBottom: '80px', display: 'flex', flexDirection: 'row', gap: '20px' }}
    >
      <NewCollapsibleTable
        rows={recordDetails.YearlyExpenditures || []}
        mainTemplate={[
          { DisplayName: 'Legislative Year', Accessor: 'LegislativeYearPeriod', IsEnabled: true },
        ]}
        subTemplates={subTemplate}
        className={'expenditures'}
        wrapperClassName={'staff-search'}
        expandable
        hideMainHeader
        hideSubTableLabels
        showCollapseAllButton
      />
    </div>
  )
}

export default LobbyistExpendituresPanel
